<template>
  <div>
    <h1 class="mt-4 mb-4 primary--text">Suivi du client</h1>
    <v-timeline dense>
      <v-timeline-item
        style="position: relative; top: -24px; margin-bottom: -10px"
        color="success"
        small
        icon="check"
      >
        Le client s'est inscrit le {{timeline.signup.at | moment('D MMMM Y à LT')}}
      </v-timeline-item>

      <v-timeline-item color="info" small v-if="timeline.missions.filter(m => m.module.name === 'EvisionPatientAskForRdv').filter(m => !m.done).length > 0">
        En attente de demande de rendez-vous du client
      </v-timeline-item>

      <div v-for="rdv in timeline.rdv" :key="rdv.id">
        <v-timeline-item color="success"
                         small
                         icon="check">
          Demande de rendez-vous le {{rdv.datetime | moment('D MMMM Y à LT')}}
        </v-timeline-item>

        <v-timeline-item v-if="!rdv.declined && !rdv.accepted"
                         color="error">
          <div>
            <span class="error--text">Rendez-vous en attente de validation</span>
          </div>
          <div>
            <v-btn round @click="accept(rdv)">
              Accepter
            </v-btn>
            <v-btn round @click="deny(rdv)">
              Refuser
            </v-btn>
          </div>
        </v-timeline-item>

        <v-timeline-item v-if="rdv.declined"
                         color="success"
                         small
                         icon="check">
          Rendez-vous refusé. Client prévenu, en attente d'une nouvelle demande de rendez-vous.
        </v-timeline-item>

        <v-timeline-item class="mt-3"
                         v-if="rdv.accepted"
                         color="success"
                         small
                         icon="check">
          Rendez-vous validé le {{rdv.datetime | moment('D MMMM Y à LT')}}
        </v-timeline-item>
      </div>
    </v-timeline>
  </div>
</template>

<script>
  import api from 'api'

  export default {
    data() {
      return {}
    },

    methods: {
      accept(rdv) {
        let refresh = this.refresh
        let snackbar = this.$mango.snackbar

        this.$mango.dialog({
          title: 'Confirmez-vous ce rendez-vous ?',
          body: "Le client sera notifié de la confirmation du rendez-vous. Il recevra un SMS de rappel la veille.",
          action() {
            api.put(`rendezvous/${rdv.id}/accept`)
              .then(() => {
                refresh()
                snackbar({text: 'Rendez-vous accepté', color: 'success'})
              })
          }
        })
      },

      deny(rdv) {
        let refresh = this.refresh
        let snackbar = this.$mango.snackbar

        this.$mango.dialog({
          title: 'Refusez-vous ce rendez-vous ?',
          body: "Le client sera notifié du refus du rendez-vous. Il pourra effectuer une autre demande de rendez-vous.",
          action() {
            api.put(`rendezvous/${rdv.id}/deny`)
              .then(() => {
                refresh()
                snackbar({text: 'Rendez-vous refusé', color: 'success'})
              })
          }
        })
      },

      refresh() {
        this.$emit('refresh')
      }
    },

    props: {
      timeline: {
        type: Object,
        required: true
      }
    }
  }
</script>
